import { FUNCTION_KEY } from "../services/constants";

const utils = {
  // --------------------------------
  //  Parse a url and break it into resource, id and verb
  // --------------------------------
  parseRequestUrl: () => {
    let url = location.hash.slice(1).toLowerCase() || "/";
    let params = url.split("&");
    let r = params[0].split("/");
    let request = {
      resource: r[1],
      id: r[2],
      verb: r[3],
    };
    request.query = params.slice(1).reduce((acc, cur) => {
      let parts = cur.split("=");
      acc[parts[0]] = parts[1];
      return acc;
    }, {});
    return request;
  },

  parseRequestUrlNonHashed: () => {
    let url = location.pathname;
    let params = url.split("&");
    let r = params[0].split("/");
    let request = {
      resource: r[1],
      id: Number(r[2]) ? r[2] : null,
      verb: r[3] ? r[3] : r[2],
    };
    request.query = params.slice(1).reduce((acc, cur) => {
      let parts = cur.split("=");
      acc[parts[0]] = parts[1];
      return acc;
    }, {});
    return request;
  },

  // --------------------------------
  //  Simple sleep implementation
  // --------------------------------
  sleep: (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },

  jsTicksToDotNetTicks: (t) => {
    return t * 10000 + 621355968000000000;
  },

  dotNetTicksToJsTicks: (t) => {
    return (t - 621355968000000000) / 10000;
  },

  timer: (name) => {
    let startTime = performance.now();
    console.log(`Starting timer '${name}'`);

    return () => {
      const stopTime = performance.now();
      let timeDifference = stopTime - startTime; //in ms

      let timeMeasure = "ms";
      if (timeDifference > 1000) {
        // strip the ms
        timeDifference /= 1000;
        timeMeasure = "s";
      }

      // get seconds
      const value = Math.round(timeDifference);
      console.log(`Elapsed for '${name}': ${value} ${timeMeasure}`);
    };
  },

  getDropDownValue: (element) => {
    return element[element.selectedIndex].value;
  },

  getSasToken: async (tableStorageAccountFqdn) => {
    let sasTokens = JSON.parse(localStorage.getItem("sas_tokens"));
    if (!sasTokens) {
      const headers = { token: localStorage.getItem("access_token") };
      // TODO add token to env vars
      const response = await fetch(
        `https://func-playoutsops-dev.azurewebsites.net/api/getsastoken?code=${FUNCTION_KEY}`,
        {
          headers: headers,
        }
      );
      const json = await response.json();
      localStorage.setItem("sas_tokens", JSON.stringify(json));
      sasTokens = json;
    }
    const tableStorageAccount = tableStorageAccountFqdn.split(".")[0].replace("https://", "");
    return sasTokens[tableStorageAccount];
  },

  parseJwt: (token) => {
    return JSON.parse(atob(token.split(".")[1]));
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  },
};

export default utils;
